import React, { useEffect, useState, useContext } from 'react'
import { Form, Field } from 'react-final-form'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { getFormErrorMessage } from '../utilities/FormHelpers'
import { UserContext } from '../UserContext.js';

/*
    props:
    values {}
    onSubmit (data)
*/
export const VehicleTypeForm = (props) => {
	const [vehicleCatOptions, setVehicleCatOptions] = useState([]);
	const user = useContext(UserContext)
	useEffect(() => {
		user.apiCall(`vehicletypeformoptions`)
			.then((res) => setVehicleCatOptions(res.data))
	}, [])

	const validate = (formData) => {
		let errors = {};

		if(!formData.vehicleTypeName || formData.vehicleTypeName === "") {
			errors.vehicleTypeName = "Name required";
		}

		if(!formData.vehicleCategoryGuid) {
			errors.vehicleCategoryGuid = "Vehicle category required";
		}

		return errors;
	}

	return (
		<Form
			onSubmit={props.onSubmit}
			validate={validate}
			initialValues={props.values}
			render={({handleSubmit}) => (
				<form onSubmit={handleSubmit} className="master-form">
					<Field name="vehicleTypeName"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<InputText {...input}
										id="vehicleTypeName"
									/>
									<label htmlFor='vehicleTypeName'>Name:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<Field name="vehicleCategoryGuid"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<Dropdown {...input}
										id="vehicleCategoryGuid"
										options={vehicleCatOptions}
										optionLabel="label"
										style={{minWidth: '12rem'}}
									/>
									<label htmlFor='vehicleCategoryGuid'>Vehicle Category:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<div className='submit-footer'>
						<Button type="submit" label="Submit" />
					</div>
				</form>
			)}
		/>
	);
}